// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oW46","field":"styles_field__2vq8O","fieldCol":"styles_fieldCol__2khEu","diffCol":"styles_diffCol__14RD_","diff":"styles_diff__3EDiG"};